import { environment } from '../environments/environment';

export const constants = {
  baseUrl: `${environment.apiURLPrefix}/`, // like 'https://alcmeon.com/c/'
  frontendBaseUrl: `${environment.frontendURLPrefix}/`, // like 'https://alcmeon.com/c/v3/'
  wsUrl: environment.wsUrl, // like 'https://ws.alcmeon.com/c/'
  xhrStatsUrl: environment.trackURLPrefix, // like 'https://track.alcmeon.com/track'
  clientVersion: environment.ajsClientVersion,
  backofficeBaseUrl: environment.backofficeUrlPrefix,
  isBackofficeActivated: environment.isBackofficeActivated,
  customFieldBaseUrl: environment.customFieldBaseUrlPrefix,
  pdfUploadFrontUrl: environment.pdfUploadFrontUrl,

  XHR_STATS_INTERVAL_TIME: 60000,
  PUBLISH_THROTTLE_MILLISECONDS: 500,
};
